<template>
  <form @submit.prevent="$emit('submit')">
    <string-form-field
      :label="$t('provider.fields.companyName')"
      :value="value.companyName"
      :error="findError('companyName')"
      @input="propertyChange('companyName', $event)"
    />
    <b-row>
      <string-form-field
        class="col-md-6"
        :label="$t('provider.fields.fiscalCode')"
        :value="value.fiscalCode"
        :error="findError('fiscalCode')"
        @input="propertyChange('fiscalCode', $event)"
      />
      <string-form-field
        class="col-md-6"
        :label="$t('provider.fields.vatNumber')"
        :value="value.vatNumber"
        :error="findError('vatNumber')"
        @input="propertyChange('vatNumber', $event)"
      />
    </b-row>

    <!--
    Il pulsante nascosto permette di sottomettere il form alla pressione
    del tasto INVIO in uno dei campi contenuti; altrimenti l'invio del
    form non avviene.
    -->
    <b-button type="submit" class="d-none"></b-button>
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";

export default {
  mixins: [EditorMixin]
};
</script>
